import { createContext } from 'react';

import { FunnelEntryPointContextValue } from './funnel_entry_point_context_value';

export const FunnelEntryPointContext = createContext<
  FunnelEntryPointContextValue | undefined
>(undefined);
